import React from "react";
import Typical from "react-typical";
import BackgroundProfile from "./img/dp.png";
import "./home.css";

export default function HeaderBlock() {
  return (
    <section class="portfolio-block block-intro HeaderBlock">
      <div class="container">
        {/* Desktop View */}
        <div className="row">
          <div className="col-md-6 HeaderBlockCol1" id="HeaderColDesktop">
            {" "}
            <div
              class="about-me"
              data-aos="zoom-in"
              data-aos-delay="200"
              data-aos-duration="800"
            >
              <p>
                <span class="display-3" style={{ fontWeight: "normal" }}>
                  Hello!{" "}
                </span>
                <Typical
                  steps={[
                    "I am Senura Jayadeva",
                    1000,
                    "I am a Student ",
                    1000,
                    "I am a Developer",
                    1000,
                    "I am a Blogger",
                    1000,
                  ]}
                  loop={Infinity}
                  wrapper="h3"
                />
              </p>

              <p>
                <span style={{ fontWeight: "normal" }}>
                  I am interested in web development, Machine Learning and IoT.
                  Always curious about new things and enjoy learning
                </span>
              </p>

              <div className="container">
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/SenuraVihanJayadeva.pdf?alt=media&token=b8dc2bea-bd22-43f7-8507-62a8685be9c1"
                  target="_blank"
                >
                  <button className="btn btn-md btn-primary">
                    {" "}
                    DOWNLOAD CV
                  </button>
                </a>
              </div>

              <div className="container">
                {" "}
                <div className="row">
                  <div
                    className="col-md-4 col-sm-2 socialIcons facebook"
                    data-aos="fade-up"
                    data-aos-delay="600"
                    data-aos-duration="800"
                  >
                    <a
                      href="https://www.facebook.com/senura.vihan/"
                      target="_blank"
                      className="facebook"
                    >
                      <i class="fab fa-facebook-square"></i>
                    </a>{" "}
                  </div>
                  <div
                    className="col-md-4 col-sm-2  socialIcons linkedin"
                    data-aos="fade-up"
                    data-aos-delay="600"
                    data-aos-duration="800"
                  >
                    {" "}
                    <a
                      href="https://www.linkedin.com/in/senura-vihan-jayadeva-7860b41a6"
                      target="_blank"
                      className="linkedin"
                    >
                      <i class="fab fa-linkedin"></i>
                    </a>
                  </div>
                  <div
                    className="col-md-4 col-sm-2 socialIcons github"
                    data-aos="fade-up"
                    data-aos-delay="600"
                    data-aos-duration="800"
                  >
                    {" "}
                    <a
                      href="https://github.com/senuravihanjayadeva"
                      target="_blank"
                      className="github"
                    >
                      <i class="fab fa-github-square"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 HeaderBlockImage">
            <img src={BackgroundProfile} id="DPHeader" />
          </div>

          {/* Mobile View */}
          <div className="col-md-6 HeaderBlockCol1" id="HeaderColMobile">
            {" "}
            <div
              class="about-me"
              data-aos="zoom-in"
              data-aos-delay="600"
              data-aos-duration="800"
            >
              <p>
                <span style={{ fontWeight: "normal" }}>Hello! </span>
                <Typical
                  steps={[
                    "I am Senura Jayadeva",
                    1000,
                    "I am a Student ",
                    1000,
                    "I am a Developer",
                    1000,
                    "I am a Blogger",
                    1000,
                  ]}
                  loop={Infinity}
                  wrapper="h3"
                />
              </p>

              <p>
                <span style={{ fontWeight: "normal" }}>
                  I am interested in web development, Machine Learning and IoT.
                  Always curious about new things and enjoy learning
                </span>
              </p>

              <div className="container">
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/SenuraVihanJayadeva.pdf?alt=media&token=b8dc2bea-bd22-43f7-8507-62a8685be9c1"
                  target="_blank"
                >
                  <button className="btn btn-md btn-primary">
                    {" "}
                    DOWNLOAD CV
                  </button>
                </a>
              </div>

              <div className="container" style={{ marginTop: "10px" }}>
                {" "}
                <div class="d-flex justify-content-center">
                  <div
                    className="col-md-4 col-sm-2 socialIcons facebook"
                    data-aos="fade-up"
                    data-aos-delay="600"
                    data-aos-duration="800"
                  >
                    <a
                      href="https://www.facebook.com/senura.vihan/"
                      target="_blank"
                      className="facebook"
                    >
                      <i class="fab fa-facebook-square"></i>
                    </a>{" "}
                  </div>
                  <div
                    className="col-md-4 col-sm-2  socialIcons linkedin"
                    data-aos="fade-up"
                    data-aos-delay="600"
                    data-aos-duration="800"
                  >
                    {" "}
                    <a
                      href="https://www.linkedin.com/in/senura-vihan-jayadeva-7860b41a6"
                      target="_blank"
                      className="linkedin"
                    >
                      <i class="fab fa-linkedin"></i>
                    </a>
                  </div>
                  <div
                    className="col-md-4 col-sm-2 socialIcons github"
                    data-aos="fade-up"
                    data-aos-delay="600"
                    data-aos-duration="800"
                  >
                    {" "}
                    <a
                      href="https://github.com/senuravihanjayadeva"
                      target="_blank"
                      className="github"
                    >
                      <i class="fab fa-github-square"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
